<template>
  <v-navigation-drawer v-model="drawer" app right permanent :width="drawerWidth">
    <v-list dense nav>
      <v-list-item v-for="item in items" :key="item.title" :to="item.to" link>
        <v-list-item-icon>
          <v-icon color="primary">{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      drawer: true,
      items: [
        { title: 'داشبورد', icon: 'fas fa-shopping-cart', to: '/' },
        { title: 'کاربر', icon: 'fas fa-user', to: '/users' },
        { title: 'محصولات', icon: 'fas fa-gift', to: '/products' },
        { title: 'رنگ‌ها', icon: 'fas fa-palette', to: '/colors' },
        { title: 'مواد', icon: 'fas fa-cube', to: '/materials' },
        { title: 'سفارشات', icon: 'fas fa-truck-fast', to: '/orders' },
        {
          title: 'دسته بندی ها',
          icon: 'fas fa-book',
          to: '/categories',
        },
        { title: 'تنظیمات', icon: 'fas fa-gears', to: '/settings' },
        { title: 'عملیات', icon: 'fas fa-tools', to: '/operations' },
      ],
    }
  },

  computed: {
    drawerWidth() {
      // Slightly smaller width on mobile and tablet
      if (this.$vuetify.breakpoint.smAndDown) {
        return 200 // Mobile: smaller width
      } else if (this.$vuetify.breakpoint.mdOnly) {
        return 220 // Tablet: medium width
      }
      return 256 // Desktop (lg and up): default width
    },
  },

  mounted() {
    // Always keep drawer open
    this.drawer = true
  },
}
</script>

<style scoped>
.v-navigation-drawer {
  background-color: #fafafa !important;
}

.v-list-item--active {
  background-color: rgba(25, 118, 210, 0.1) !important;
  border-right: 3px solid #1976d2; /* Right side navigation: border-right */
}

.v-list-item--active .v-list-item-icon .v-icon {
  color: #1976d2 !important;
}

.v-list-item--active .v-list-item-title {
  color: #1976d2 !important;
  font-weight: 600;
}

.v-list-item:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

.v-list-item-icon .v-icon {
  font-size: 20px;
}

/* RTL specific adjustments */
.v-list-item {
  text-align: right;
}

.v-list-item-title {
  text-align: right !important;
  font-size: 14px;
}

/* Fix icon positioning for RTL */
.v-list-item-icon {
  margin-left: 12px !important;
  margin-right: 0 !important;
}

/* Smaller font and spacing on mobile/tablet */
@media (max-width: 959px) {
  .v-list-item-title {
    font-size: 13px;
  }

  .v-list-item-icon .v-icon {
    font-size: 18px;
  }

  .v-list-item {
    padding-left: 8px !important;
    padding-right: 8px !important;
    min-height: 44px;
  }
}
</style>
